export default class vehiculo {
    constructor($scope,
                $routeParams,
                method,
                vehiculoService,
                marcasService,
                $location,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.location = $location;
        this.modal = $uibModal;
        this.toastr = toastr;
        switch (method) {
            case 'list':
                this.list(vehiculoService);
                break;
            case 'new':
                this.create(vehiculoService, marcasService);
                break;
            case 'view':
                this.view($routeParams,
                    vehiculoService,
                    marcasService);
                break;
        }
    }

    list(vehiculoService) {

        let self = this.scope;
        vehiculoService.getAll().then((resp, err) => {
            self.vehiculos = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.vehiculos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, vehiculoService);

        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                vehiculoService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Vehiculo eliminado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al eliminar el vehiculo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
        */
    }

    create(vehiculoService, marcasService) {

        marcasService.getAll({"grupo":'vehiculo'})
            .then((resp)=> {
                this.scope.marcas = resp.data.message;
            });
        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                vehiculoService.save(this.scope.vehiculo).then((resp) => {
                    this.toastr.success('Vehiculo creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/vehiculo');
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al crear el vehiculo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
    }

    view($routeParams,
         vehiculoService, marcasService) {

        marcasService.getAll({"grupo":'vehiculo'})
            .then((resp)=> {
                this.scope.marcas = resp.data.message;
            });

        this.scope.aux = {};
        vehiculoService.getById({_id: $routeParams.id}).then((resp) => {
            this.scope.vehiculo = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                vehiculoService.update(this.scope.vehiculo).then((resp) => {
                    this.toastr.success('Vehiculo modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/vehiculo');
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al modificar el vehiculo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Vehiculo</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el Vehiculo: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.patente;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.vehiculos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Vehiculo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Vehiculo!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/vehiculo/vehiculo.js